
import React from 'react';
import { Route } from 'react-router-dom';
import Checkout from '@/pages/Checkout';
import Confirmation from '@/pages/Confirmation';

export const CheckoutRoutes = () => (
  <>
    <Route path="/checkout" element={<Checkout />} />
    <Route path="/checkout/confirm" element={<Checkout />} />
    <Route path="/checkout/success" element={<Confirmation />} />
  </>
);
